import React from 'react';
import styled from 'styled-components';

import { NewTypeaheadProps } from '../../NewTypeahead';
import CoreTypeahead from '../../../_common/CoreTypeahead/CoreTypeahead';

import { ErrorText } from '../../../_common/Controller/components/ControllerError/ControllerError';

import { colorTokens } from '../../../../tokens/globals/tokens';

const StyledTypeahead = styled(CoreTypeahead)`
  position: static;

  ${ErrorText} {
    padding: 4px 2px;
    margin: 0 8px;
    border-top: 1px solid ${colorTokens.GlobalBorderSeparationRegularDefault};
  }
`;

function TableTypeahead(props: NewTypeaheadProps) {
  const { className, style, ...otherProps } = props;

  return <StyledTypeahead {...otherProps} />;
}

TableTypeahead.defaultProps = {
  keepOpen: false,
  option: undefined,
  allowCustom: false,
  emptyMessage: undefined,
  scrollable: false,
};

export default TableTypeahead;
